import trains_common_queryTheCitySite from '@/lib/data-service/trains/trains_common_queryTheCitySite';
import web_common_getCurrentUserAuditStatus from '@/lib/data-service/default/web_common_getCurrentUserAuditStatus';

import quickly_create_file from 'nllib/src/file/quickly_create_file';
import OssClient from 'yinzhilv-js-sdk/frontend/common-project/lib/system-docking/aliyun/oss/frontend/client';

export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
    const test_001 = function () {
      trains_common_queryTheCitySite().then(function (data) {
        console.log(data);
      });
    };

    const test_002 = function () {
      const returnValue_quicklyCreateFile = quickly_create_file({createType: '000'});
      const fileContent = returnValue_quicklyCreateFile.fileContent;
      const fileName = returnValue_quicklyCreateFile.fileName;
      const file = returnValue_quicklyCreateFile.file;

      const aOssClient = new OssClient();
      aOssClient.multipartUpload({
        file: file,
        progress: function* (p) {
          console.log('Progress: ' + p);
        }
      })
        .then(function (data) {
          console.log(data);
        })
      ;
    };

    const test_003 = function () {
      web_common_getCurrentUserAuditStatus().then(function (data) {
        console.log(data);
      });
    };
    // test_003();

  },
}
